<template>
  <span class="le-spinner"></span>
</template>

<style lang="less" scoped>
@import "@dsk/styles/all";

.le-spinner {
  display: inline-block;
  width: 28px;
  min-width: 28px;
  height: 28px;
  animation: load 700ms infinite ease-in-out;
  border-width: 0.2em;
  border-style: solid;
  border-radius: 50%;
  border-color: fade(@colors[@neutrals][500], 15%);
  border-left-color: fade(@colors[@neutrals][500], 30%);
}

@keyframes load {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
